import React from 'react'
import PropTypes from 'prop-types'
import Image from '../image/image'
import { Link } from 'gatsby'

import './caseStudyNext.css'
import arrowDown from '../../images/arrow-down.svg'

const CaseStudyNext = ({ data }) => {
  return (
    <section className="caseStudyNext">
      <div className="inner">
        <div className="image">
          <Image file={data.featuredImage} alt="project image"></Image>
        </div>
        <Link className="content" to={'/work/' + data.slug.current}>
          <p>Next project</p>
          <img src={arrowDown} alt={data.client} />
        </Link>
      </div>
    </section>
  )
}

CaseStudyNext.propTypes = {
  data: PropTypes.object,
}

export default CaseStudyNext
